module.exports = __webpack_public_path__ + "img/Arrow_Next_Light.2570e305.svg";